import React from 'react'
import ChatComponent from '../../../components/Chat'

function AdminChat() {
    return (
        <div>
            <ChatComponent />
        </div>
    )
}

export default AdminChat